import classNames from 'classnames';
import {
	AssertNever,
	type Item,
	type ItemDisplayNameType,
} from 'pandora-common';
import type { ReactElement } from 'react';
import { useAccountSettings } from '../../../services/accountLogic/accountManagerHooks.ts';

export function WardrobeItemName({
	item,
	forceDisplayType,
}: {
	item: Item;
	forceDisplayType?: ItemDisplayNameType;
}): ReactElement {
	const { wardrobeItemDisplayNameType } = useAccountSettings();
	const displayType = forceDisplayType ?? wardrobeItemDisplayNameType;

	const isCustomName = displayType === 'custom' && !!item.name && item.name !== item.asset.definition.name;
	return (
		<span className={ classNames('itemName', isCustomName ? 'custom' : null) }>
			{ ResolveItemDisplayName(item, displayType) }
		</span>
	);
}

export function ResolveItemDisplayName(item: Item, itemDisplayNameType: ItemDisplayNameType): string {
	if (item.isType('roomDeviceWearablePart')) {
		return ResolveItemDisplayNameType(item.asset.definition.name, item.roomDevice?.name, itemDisplayNameType);
	} else {
		return ResolveItemDisplayNameType(item.asset.definition.name, item.name, itemDisplayNameType);
	}
}

export function ResolveItemDisplayNameType(original: string, custom: string | null | undefined, itemDisplayNameType: ItemDisplayNameType): string {
	if (custom == null || custom === '' || custom === original)
		return original;

	switch (itemDisplayNameType) {
		case 'original':
			return original;
		case 'custom':
			return custom;
		case 'custom_with_original_in_brackets':
			return `${custom} (${original})`;
		default:
			AssertNever(itemDisplayNameType);
	}
}
